import React, {useEffect} from 'react';
import common from 'common.module.css';
import appIcon from 'surveys/insomnia_funnel/paywall/assets/clinic_scheduled_icon.png';
import styles from './AppointmentConfirmation.module.css';
import {getValueFromSurveyData} from 'utils/getValueFromSurveyData';
import {formatAppointmentStartTime} from '../utils';

const Bullet = () => (
  <svg
    className={styles.bulletIcon}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0Z"
      fill="#E8DEFF"
    />
    <path
      d="M15.127 7.46875L9.10986 13.4858L4.97311 9.34909"
      stroke="#382365"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const bulletPoints = [
  '80% who start with an expert session get to healthy sleep, faster.',
  'Covered by insurance. We’re working on getting your estimated cost.',
  'Cancel or reschedule 24 hours before your session to avoid a $50 no show fee.',
];

const AppointmentConfirmation: React.FC = () => {
  const appointmentStartTime = getValueFromSurveyData('appointment_start_time');

  const formattedAppointmentTime = formatAppointmentStartTime(appointmentStartTime);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo({top: 0, left: 0, behavior: 'auto'});
    }
  }, []);

  return (
    <div className={styles.page} data-testid="screen-appointment-confirmation">
      <div className={`${common.display1} ${styles.title}`}>You&apos;re All Set!</div>

      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.appIconWrapper}>
            <img src={appIcon} alt="RISE session" className={styles.appIcon} />
          </div>

          <div className={styles.sessionCopy}>
            <div className={styles.sessionTime}>{formattedAppointmentTime}</div>
            <div className={styles.sessionTitle}>Your session is confirmed!</div>
          </div>
        </div>

        <p className={styles.description}>
          Work one-on-one with your sleep expert to kick off your plan, explore your insomnia risk, and get continued
          support to keep your plan on track.
        </p>

        <ul className={styles.benefits}>
          {bulletPoints.map(point => (
            <li key={point} className={styles.benefitItem}>
              <Bullet />
              <span>{point}</span>
            </li>
          ))}
        </ul>
      </div>

      <p className={styles.contactInfo}>
        Any questions? Contact us at{' '}
        <a href="mailto:care@risescience.com" className={styles.contactLink}>
          care@risescience.com
        </a>{' '}
        <br />
        or text us at{' '}
        <a href="tel:+13123135723" className={styles.contactLink}>
          (312) 313-5723
        </a>
      </p>
    </div>
  );
};

export default AppointmentConfirmation;
